export const forgotPasswordStyles = {
  marginAuto1: {
    margin: "auto",
  },
  formInput: {
    marginBottom: "16px",
  },
  signInHeading: {
    fontSize: "24px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "20px",
  },
  signInDescription: {
    fontSize: "16px",
    textAlign: "center",
    marginBottom: "24px",
  },
  centerFormButton: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "24px",
  },
  forgotButton: {
    borderRadius: "5px",
  },
  signInButton: {
    width: "100%",
    maxWidth: "400px",
  },
  privacyPolicyTextStyle: {
    height: "100%",
    fontSize: "14px",
    textAlign: "center",
    // display: "flex",
    // alignItems: "center"
    // justifyContent: "flex-end",
    // marginTop: "-10px",
    // marginLeft: "120px",
  },
  logoContainer: {
    margin: "auto",
  },
  logoStyle: {
    display: "block",
    margin: "0 auto",
    maxWidth: "250px",
    marginBottom: "20px",
  },
  containerA: {
    height: "calc(100dvh - 60px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    maxWidth: "600px",
    margin: "auto",
    paddingTop: "20px",
  },
  containerB: {
    width: "80%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    gap: "20px",
  },

  fixFooter: {
    position: "fixed",
    width: "100%",
    bottom: 0,
  },
};